import request from "@/request/index";

// 列表
export function getListData(params) {
  return request({
    url: "/momoda/product_list",
    method: "get",
    params,
  });
}
// 详情
export function getListDataDetail(id) {
  return request({
    url: `/momoda/product_detail/?id=${id}`,
    method: "get",
  });
}
// 门店列表
export function store_list(params) {
  return request({
    url: `/v1/momoda/store_list`,
    method: "get",
    params,
  });
}
